<template>
    <div class="form-group nps mx-auto center-question mb-2">
      
      <div v-html="question.title" class="col-form-label pt-0 form-group" style="padding-bottom: 0.75rem; text-align: justify; padding-right: 0.9rem;"></div>
      <div class="pb-2">
        <span class="pull-left ml-3">Poco Probable</span>
        <span class="pull-right mr-3">Muy Probable</span>
      </div>
    
      <br>
      <b-form-group>
        <b-form-radio-group
          id="radios1"
          v-model="selected"
          :options="options"
          name="radioOpenions"
          :class="selected"
          @input="changeStep()">
        </b-form-radio-group>
      </b-form-group>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    defaultValue: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      selected: null,
      options: []
    };
  },
  watch: {
    // whenever question changes, this function will run
    question: function (newVal, oldVal) { // watch it
      this.updateValues();
      this.setDefaultValue();
    }
  },
  mounted () {
    this.updateValues();
    this.setDefaultValue();
  },
  methods: {
    changeStep () {
      /* send object and with value, next Question id and previus, and set value in json reactive */ 
      this.question.value = null;
      this.question.value = this.selected.value;
      this.$emit('change-step', this.selected);
    },
    updateValues () {
      this.options = [];
      for (let i = 0; i < this.question.options.length; i++) {
        this.options.push({
          value: { 
            value: String(i), 
            nextQuestionId: this.question.options[i].next_question_id, 
            previusQuestionId: this.question.options[i].previus_question_id
          },
          text: i
        });
      }
    },
    setDefaultValue () {
      let _self = this;
      if (this.defaultValue != null) {
        let auxValue = this.options.filter(function (option) {
          return option.value.value === _self.defaultValue;
        })[0];
        this.selected = auxValue.value;
        this.changeStep();
      }
    }
  }
};
</script>

<style lang="css">
  .nps .custom-control{
    padding-left: 0;
  }
  .nps .custom-control-label{
    width: 3.5rem;
    height: 3.5rem;
  }
  .nps .col-form-label{
    margin-bottom: 1rem;
    font-size: 20px;
    font-weight: bold;
  }
  .nps .custom-control-label span{
    position: absolute;
    width: 3.5rem;
    height: 3.5rem;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1.1rem;
    font-size: 20px;
  }
  .nps .custom-control-label{
    display: flex;
    align-items: flex-end;
    position: relative;
  }
  .nps .custom-control-label::before {
    width: 3.5rem;
    height: 3.5rem;
    left: 50%;
    margin-left: -1.75rem;
    top: 0;
  }
  .nps .custom-control-label::after {
    background-size: 80%;
    margin-left: -.5rem;
    top: .5rem;
    left: 50%;
  }
  .nps .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    background-image: none;
  }
  .nps .custom-radio .custom-control-input:checked ~ .custom-control-label span {
    color: #fff;
  }
  @media screen and (max-width: 768px){
    .nps .custom-control {
      width: 6%;
    }
    .nps .custom-control + .custom-control{
      margin-top: 8px;
    }
    .nps .custom-control .custom-control-label {
      display: block;
      margin: 0 auto;
    }
    .nps .custom-control-label span{
      position: absolute;
      width: 2.5rem;
      height: 3.5rem;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 1rem;
      font-size: 20px;
    }
  }

  @media only screen and (max-width: 600px) {
    .nps .custom-control{
      width: 12%;
      padding-left: 10px;
    }
    .nps .custom-control-label span{
      position: absolute;
      width: 2.1rem;
      height: 3.5rem;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 1rem;
      font-size: 20px;
    }

  }
  @media only screen and (orientation: portrait) and (max-width: 475px)  {
    .nps .custom-control-label span{
      position: absolute;
      width: 1.8rem;
      height: 3.5rem;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 14px;
    }
    .nps .custom-control{
      padding-left: 10px;
      margin-left: 5px
    }
    .nps .col-form-label{
      margin-bottom: 1rem;
      font-size: 16px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/surveys/v2/components/Nps.vue